<template>
  <div id="regBylink-container">
    <v-row class="px-2 pt-4">
      <v-col
        lg="6"
        md="6"
        sm="12"
        xs="12"
        offset-lg="3"
        offset-md="3"
        offset-sm="0"
        justify="center"
        class="pa-0"
      >
        <v-overlay v-if="!pageLoaded" :value="overlay">
          <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>

        <div v-if="pageLoaded">
          <v-col v-if="logo" align="center">
            <v-img :src="require(`@/assets/${logo}`)" width="25%"></v-img>
          </v-col>

          <v-col
            v-if="!(pbl.processed === 1 || path)"
            md="12"
            class="reg-form-col"
          >
            <v-card class="reg-form-card">
              <v-card-title class="px-3">Card Details</v-card-title>
              <v-divider></v-divider>
              <div class="px-4 py-2 pb-2">
                <!-- Card Selector -->
                <!-- <v-row v-if="'scheduleId' in pbl && pbl.scheduleId != null">
                                        <v-col md="12" class="pt-6 pb-0">
                                            <v-select
                                                v-model="exCard"
                                                :items="activeCards"
                                                required
                                                dense
                                                label="Select Card"
                                                return-object
                                                @change="cardHandle"
                                            >
                                            </v-select>
                                        </v-col>
                                    </v-row> -->

                <!-- Existing Card -->
                <v-col
                  v-if="exCard && exCard.value"
                  md="12"
                  class="pb-0"
                  align="center"
                  justify="center"
                >
                  <v-img
                    v-show="paymentBrand == 'visa'"
                    src="@/assets/visa.png"
                    width="200"
                    transition="fade-transition"
                  ></v-img>
                  <v-img
                    v-show="paymentBrand == 'master'"
                    src="@/assets/mastercard-small.png"
                    width="200"
                    transition="fade-transition"
                  ></v-img>

                  <div>
                    <div class="mt-8">
                      <b>Reference: </b>{{ card.merchantTransactionId }}
                    </div>
                    <div class="mt-2">
                      <b>Card Number: </b
                      >{{
                        `${exCard.cardData.bin}******${exCard.cardData.last4Digits}`
                      }}
                    </div>
                    <div class="mt-2">
                      <b>Card Holder: </b>{{ exCard.cardData.holder }}
                    </div>
                    <div class="mt-2"><b>Card Expiry: </b>{{ expiry }}</div>
                    <div class="mt-2">
                      <b>Add On: </b>{{ exCard.cardData.createdAt }}
                    </div>
                    <div class="mt-2 mb-2">
                      <b>Amount: </b>{{ `${card.currency} ${card.amount}` }}
                    </div>
                  </div>
                </v-col>

                <!-- New Card -->
                <div v-show="!('value' in exCard) || !exCard.value">
                  <v-row>
                    <!-- Reference -->
                    <v-col md="12" class="py-0">
                      <v-text-field
                        v-model="card.merchantTransactionId"
                        label="Reference"
                        readonly
                      ></v-text-field>
                    </v-col>
                  </v-row>

                  <v-row>
                    <!-- Amount -->
                    <v-col md="12" class="py-0">
                      <v-text-field
                        v-model="card.amountCurr"
                        label="Amount"
                        readonly
                      ></v-text-field>
                    </v-col>
                  </v-row>

                  <v-row>
                    <!-- Address 1 -->
                    <v-col md="12" class="py-0">
                      <v-text-field
                        v-model="card.address1"
                        :rules="[rules.required]"
                        label="1st Line Address"
                      ></v-text-field>
                    </v-col>
                  </v-row>

                  <v-row>
                    <!-- City -->
                    <v-col md="12" class="py-0">
                      <v-text-field
                        v-model="card.city"
                        label="City"
                        :rules="[rules.required]"
                      ></v-text-field>
                    </v-col>
                  </v-row>

                  <v-row>
                    <!-- Postcode -->
                    <v-col md="12" class="py-0">
                      <v-text-field
                        v-model="card.postcode"
                        label="Postcode"
                        :rules="[rules.required]"
                      ></v-text-field>
                    </v-col>
                  </v-row>

                  <v-row>
                    <!-- Country -->
                    <v-col md="12" class="py-0">
                      <v-select
                        v-model="card.country"
                        label="Country"
                        :items="countries"
                        item-text="name"
                        item-value="code"
                        :rules="[rules.required]"
                      ></v-select>
                    </v-col>
                  </v-row>

                  <v-row class="pb-2">
                    <v-col md="12" class="py-0">
                      <v-row>
                        <v-col md="12" class="py-0">
                          <form
                            ref="paymentForm"
                            v-if="host == 'localhost'"
                            :action="url"
                            class="paymentWidgets"
                            data-brands="VISA MASTER AMEX"
                          ></form>
                          <form
                            ref="paymentForm"
                            v-else
                            :action="url"
                            class="paymentWidgets"
                            data-brands="VISA MASTER AMEX"
                          ></form>
                        </v-col>
                      </v-row>
                    </v-col>
                  </v-row>

                  <v-col v-if="!checkoutCreated" align="end" class="pa-0">
                    <v-btn
                      :dark="fieldsCheck"
                      color="primary"
                      class="mb-3"
                      :disabled="!fieldsCheck"
                      @click="createCheckout"
                    >
                      Create Checkout
                    </v-btn>
                  </v-col>
                </div>
              </div>

              <v-divider></v-divider>

              <v-card-actions v-if="exCard && exCard.value">
                <v-spacer></v-spacer>
                <!-- <v-btn
                                        v-if="ifApple"
                                        @click="applePay"
                                        color="black"
                                        elevation="0"
                                        class="pa-2"
                                    ><v-img src="@/assets/apple-pay.svg" width="1"></v-img></v-btn>
                                    <v-btn
                                        v-if="(ifChrome && ifPaymentRequest)"
                                        @click="paymentRequest"
                                        outlined
                                        class="pa-2"
                                    ><v-img src="@/assets/google-pay.svg" width="1"></v-img></v-btn> -->
                <v-btn @click="recurring" color="primary" type="submit"
                  >Pay Now</v-btn
                >
              </v-card-actions>
            </v-card>
          </v-col>

          <div v-if="(pbl !== null || path) && !result">
            <v-col v-if="pbl.processed === 1 || path" md="12" align="middle">
              Link Expired.
            </v-col>
          </div>

          <v-col v-if="result" md="12">
            <v-row
              v-if="result && result.result.code == '000.000.000'"
              class="mt-4"
            >
              <v-col md="12" class="py-0">
                <v-alert type="success" text border="left" class="mb-2">
                  Code: {{ result.result.code }}<br />
                  Description: {{ result.result.description }}
                </v-alert>
              </v-col>
            </v-row>
            <v-row
              v-if="result && result.result.code == '000.200.000'"
              class="mt-4"
            >
              <v-col md="12" class="py-0">
                <v-alert type="info" text border="left" class="mb-2">
                  Code: {{ result.result.code }}<br />
                  Description: {{ result.result.description }}
                </v-alert>
              </v-col>
            </v-row>
            <v-row
              v-else-if="
                result &&
                  result.result.code != '000.000.000' &&
                  result.result.code != '000.200.000'
              "
              class="mt-4"
            >
              <v-col md="12" class="py-0">
                <v-alert type="error" text border="left">
                  Code: {{ result.result.code }}<br />
                  Description: {{ result.result.description }}
                </v-alert>
              </v-col>
            </v-row>
          </v-col>
        </div>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import axios from "axios";

export default {
  data() {
    return {
      url: window.location.href,
      pbl: null,
      card: {
        merchantTransactionId: null,
        amount: null,
        currency: null,
        address1: null,
        city: null,
        postcode: null,
        country: null,
        channel: null,
      },
      client: {
        firstName: null,
        surname: null,
        mobile: null,
        email: null,
        dob: null,
      },
      exCard: { value: null },
      exCards: [],
      path: null,
      currencies: [
        { value: "EUR", text: "EUR" },
        { value: "GBP", text: "GBP" },
      ],
      rules: {
        required: (v) => !!v || "Required.",
      },
      result: null,
      logo: null,
      countries: [],
      checkoutCreated: false,
      payMethod: [
        {
          supportedMethods: "basic-card",
          data: {
            supportedNetworks: ["visa", "mastercard"],
            supportedTypes: ["credit", "debit"],
          },
        },
      ],
      applePayMethod: {
        supportedMethods: "https://apple.com/apple-pay",
        data: {
          version: 3,
          merchantIdentifier: "merchant.totalcontrol",
          merchantCapabilities: [
            "supports3DS",
            "supportsCredit",
            "supportsDebit",
          ],
          supportedNetworks: ["masterCard", "visa"],
          countryCode: "GB",
        },
      },
      details: {
        total: {
          label: "Total",
          amount: { currency: null, value: null },
        },
      },
      options: { requestShipping: false },
      showRes: false,

      pageLoaded: false,
    };
  },
  computed: {
    activeCards() {
      let cards = [
        {
          text: "Take a payment using a new card",
          value: null,
          cardData: null,
        },
      ];
      this.exCards.filter((e) => {
        cards.push({
          text: `${e.bin}******${e.last4Digits} - ${e.paymentBrand} - ${e.holder}`,
          value: e.id,
          cardData: e,
        });
      });
      return cards;
    },
    paymentBrand() {
      return this.exCard &&
        this.exCard.value &&
        this.exCard.cardData.bin.toString().startsWith(4)
        ? "visa"
        : this.exCard &&
          this.exCard.value &&
          this.exCard.cardData.bin.toString().startsWith(5)
        ? "master"
        : false;
    },
    ifApple() {
      return window.ApplePaySession ? true : false;
    },
    ifPaymentRequest() {
      return window.PaymentRequest ? true : false;
    },
    ifChrome() {
      return navigator.userAgent.match("CriOS") ||
        navigator.userAgent.match("Chrome")
        ? true
        : false;
    },
    fieldsCheck() {
      if (
        this.card.address1 &&
        this.card.city &&
        this.card.postcode &&
        this.card.country
      ) {
        return true;
      } else {
        return false;
      }
    },
  },
  beforeMount() {
    this.getCountries();
    this.clicked();
    this.getPayByLink();

    if (this.$route.query.resourcePath) {
      this.path = this.$route.query.resourcePath
        .replace("/v1/checkouts/", "")
        .replace("/payment", "");
      this.getPaymentStatus();
    }
  },
  methods: {
    createCheckout() {
      this.checkoutCreated = true;
      this.result = null;

      axios({
        method: "post",
        url: `cnp-checkout`,
        data: {
          card: this.card,
          client: this.client,
          exCard: this.exCard,
          source: "PBL",
        },
        config: {
          headers: { "Content-Type": "application/x-www-form-urlencoded" },
        },
      })
        .then((response) => {
          var jq = document.createElement("script");
          jq.setAttribute(
            "src",
            "https://cdnjs.cloudflare.com/ajax/libs/jquery/3.4.1/jquery.min.js"
          );
          document.head.appendChild(jq);

          const cnp = document.createElement("script");
          cnp.setAttribute("src", "https://dally.totalprocessing.com/cnp.js");
          document.head.appendChild(cnp);

          const cnpScript = document.createElement("script");
          this.checkoutId = response.data.id;
          console.log(this.checkoutId);
          console.log(response.data);
          cnpScript.setAttribute(
            "src",
            "https://eu-prod.oppwa.com/v1/paymentWidgets.js?checkoutId=" +
              this.checkoutId
          );
          document.head.appendChild(cnpScript);
        })
        .catch((e) => {
          this.errors.push(e);
        });
    },
    getPaymentStatus() {
      axios({
        method: "post",
        url: `get-payment-status-live`,
        data: { path: this.path, token: this.$route.params.id },
        config: {
          headers: { "Content-Type": "application/x-www-form-urlencoded" },
        },
      })
        .then((response) => {
          console.log(response.data);
          this.result = response.data;
          this.pageLoaded = true;
        })
        .catch((e) => {
          this.pageLoaded = true;
          this.errors.push(e);
        });
    },
    recurring() {
      let payload = {
        card: this.exCard.cardData,
        payment: {
          clientId: this.card.clientId,
          scheduleId: this.card.scheduleId,
          paymentId: this.card.paymentId,
          amount: this.card.amount,
        },
        client: this.client,
        paymentType: "PBL",
        currency: this.card.currency,
      };

      axios({
        method: "post",
        url: "recurring-payment-live",
        data: payload,
        config: {
          headers: { "Content-Type": "application/x-www-form-urlencoded" },
        },
      })
        .then((response) => {
          this.showRes = true;
          this.result = response.data;
          console.log("pyRes", response.data);
          console.log(this.result);
          console.log(this.path);
          this.getPayByLink();
        })
        .catch((e) => {
          this.errors.push(e);
        });
    },
    getPayByLink() {
      axios({
        method: "post",
        url: "get-pay-by-link",
        data: { token: this.$route.params.id },
        config: {
          headers: { "Content-Type": "application/x-www-form-urlencoded" },
        },
      })
        .then((response) => {
          this.pbl = response.data;
          console.log("pbl:", this.pbl);

          this.card.token = response.data.hash;
          this.card.merchantTransactionId = response.data.merchantTransactionId;
          this.card.channel = response.data.channelUuid;
          this.card.amount = response.data.amount;
          this.card.currency = response.data.currency;
          this.card.amountCurr =
            response.data.amount + " " + response.data.currency;
          this.card.basicCard = 0;
          this.logo = response.data.logo;
          this.details.total.amount.value = response.data.amount;
          this.details.total.amount.currency = response.data.currency;

          if ("scheduleId" in response.data) {
            this.card.clientId = response.data.clientId;
            this.card.scheduleId = response.data.scheduleId;
            this.card.paymentId = response.data.paymentId;
          }

          this.client = {
            firstName: response.data.firstName,
            surname: response.data.surname,
            mobile: response.data.mobile,
            email: response.data.email,
            dob: response.data.dob,
          };

          this.getCards();
        })
        .catch((e) => {
          this.errors.push(e);
          this.pageLoaded = true;
        });
    },
    getCards() {
      axios({
        method: "post",
        url: "get-active-cards",
        data: { clientId: this.card.clientId, token: this.$route.params.id },
        config: {
          headers: { "Content-Type": "application/x-www-form-urlencoded" },
        },
      })
        .then((response) => {
          this.exCards = response.data;
          console.log("recurring card", this.card);

          if (this.path == null) {
            this.pageLoaded = true;
          }
        })
        .catch((e) => {
          this.errors.push(e);
          this.pageLoaded = true;
        });
    },
    getCountries() {
      axios({
        method: "get",
        url: "get-countries",
        config: {
          headers: { "Content-Type": "application/x-www-form-urlencoded" },
        },
      })
        .then((response) => {
          this.countries = response.data;
        })
        .catch((e) => {
          this.errors.push(e);
        });
    },
    clicked() {
      axios({
        method: "post",
        url: "pay-by-link-clicked",
        data: { token: this.$route.params.id },
        config: {
          headers: { "Content-Type": "application/x-www-form-urlencoded" },
        },
      })
        .then((response) => {})
        .catch((e) => {
          this.errors.push(e);
        });
    },
    paymentRequest() {
      const request = new PaymentRequest(
        this.payMethod,
        this.details,
        this.options
      );

      request
        .show()
        .then((res) => {
          this.card.number = res.details.cardNumber;
          this.card.cvv = res.details.cardSecurityCode;
          this.card.holder = res.details.cardholderName;
          this.card.expiry = `${
            res.details.expiryMonth
          }/${res.details.expiryYear.slice(-2)}`;
          this.card.address1 = res.details.billingAddress.addressLine[0];
          this.card.postcode = res.details.billingAddress.postalCode;
          this.card.basicCard = 1;
          this.onSubmit(false);
          res.complete("success");
        })
        .catch((err) => {
          console.error("Something went wrong", err.message);
        });
    },
    async applePay() {
      try {
        const request = new PaymentRequest(
          [this.applePayMethod],
          this.details,
          this.options
        );

        request.onmerchantvalidation = function(event) {
          axios({
            method: "post",
            url: "applepay-validation",
            data: {
              appleValidationUrl: event.validationURL,
              appleMerchantId: "merchant.totalcontrol",
              displayName: "Total Control",
            },
            config: {
              headers: { "Content-Type": "application/x-www-form-urlencoded" },
            },
          })
            .then((response) => {
              console.log(response);
              event.complete(response.data);
            })
            .catch((e) => {
              this.errors.push(e);
            });
        };

        const response = await request.show();

        axios({
          method: "post",
          url: "applepay-payment",
          data: { token: response.details.token, card: this.card },
          config: {
            headers: { "Content-Type": "application/x-www-form-urlencoded" },
          },
        })
          .then((res) => {
            console.log(res.data.result);
            if (res.data.result.code == "000.000.000") {
              this.result = res.data;
              response.complete("success");
            } else {
              this.result = res.data;
              response.complete("failure");
            }
          })
          .catch((e) => {
            this.errors.push(e);
          });
      } catch (e) {
        console.log(e);
      }
    },
  },
};
</script>

<style scoped>
#regBylink-container {
  margin-left: -55px;
}

.card-items {
  font-family: "Courier New", Courier, monospace;
  font-weight: 600;
  fill: #fff;
}

.reg-form-svg {
  z-index: 10;
  position: relative;
}

.reg-form-col {
  z-index: 0;
  position: relative;
}
</style>
